import Carousel from 'react-material-ui-carousel'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import { Paper } from '@mui/material'

import { useCircleInfo } from '~/features/circle-info/queries/useCircleInfo'
import { DateType, GoodsType } from '~/features/circle-participation/utils/type'
import Bg from '~/shared/assets/background/circle-participation-1.png'
// import BgPc from '~/shared/assets/background/home-participation.png'
// import BgMobile from '~/shared/assets/background/home-participation-mobile.png'
import CircleDefaultImage from '~/shared/assets/images/CircleDefaultImage.png'
import Button from '~/shared/components/buttons/Button'
import Tag from '~/shared/components/tags/Tag'
import useViewport from '~/shared/hooks/useViewport'
import theme from '~/shared/styles/theme'
import isValidURL from '~/shared/utils/isValidUrl'

function CircleDetail() {
  const { circleId } = useParams()
  const viewport = useViewport()
  const isMobile = viewport < theme.deviceSizes.medium
  const backgroundImage = isMobile ? Bg : Bg

  const { data: circleInfo } = useCircleInfo(circleId || '')

  const handleOpenNewTab = (url: string) => {
    window.open(url, '_black', 'noopener noreferrer')
  }

  return (
    <>
      {circleInfo && circleInfo?.data.userBoothApplication && (
        <Wrapper>
          <BackgroundImage src={backgroundImage} alt="background image" />
          <CircleMainInfoBox>
            <CircleThumbnail
              src={
                circleInfo?.data.userBoothApplication.image_info?.url ||
                CircleDefaultImage
              }
              alt="circle-thumbnail"
              onClick={() =>
                handleOpenNewTab(
                  circleInfo?.data.userBoothApplication.image_info?.url,
                )
              }
            />
            <CircleMainInfo>
              <div className="title">
                {circleInfo?.data.userBoothApplication.booth_name}
              </div>
              <div className="hashtags">
                {circleInfo?.data.userBoothApplication.tag &&
                  circleInfo?.data.userBoothApplication.tag
                    .split(',')
                    .map((hashtag) => {
                      return (
                        <div key={hashtag} className="hashtag">
                          {hashtag}
                        </div>
                      )
                    })}
              </div>

              <TagBox className="center">
                <Tag $size="sm" $variant="gray">
                  서클 배치
                </Tag>
                <div className="desc">
                  {circleInfo?.data.userBoothApplication.booth_no ||
                    '(배치 준비중)'}
                </div>
              </TagBox>
              <TagBox className="center">
                <Tag $size="sm" $variant="gray">
                  대표자 닉네임
                </Tag>
                <div className="desc">
                  {circleInfo?.data.userBoothApplication.user_nickname}
                </div>
              </TagBox>
              <TagBox className="center">
                <Tag $size="sm" $variant="gray">
                  대표자 이메일
                </Tag>
                <div className="desc">
                  {circleInfo?.data.userBoothApplication.user_email}
                </div>
              </TagBox>
              <TagBox className="center">
                <Tag $size="sm" $variant="gray">
                  부스 운영일
                </Tag>
                <div className="desc">
                  {circleInfo?.data.userBoothApplication.date_type
                    .split(',')
                    .map((date) => {
                      return (
                        <span key={date}>
                          {DateType[date as keyof typeof DateType]}{' '}
                        </span>
                      )
                    })}
                </div>
              </TagBox>

              {isValidURL(circleInfo?.data.userBoothApplication.homepage) && (
                <StyledButton
                  $fontSize={18}
                  $width={206}
                  $height={58}
                  $variant="transparent"
                >
                  <a
                    href={circleInfo?.data.userBoothApplication.homepage}
                    target="_blank"
                  >
                    홍보 페이지 보러가기
                  </a>
                </StyledButton>
              )}
            </CircleMainInfo>
          </CircleMainInfoBox>

          {viewport < theme.deviceSizes.medium ? (
            <CircleImageCarousel>
              {circleInfo?.data.userBoothApplication.goods_list.length > 0 &&
                circleInfo?.data.userBoothApplication.goods_list.map(
                  (goods) => {
                    return (
                      <StyledPaper key={goods.id}>
                        <img
                          src={goods.url}
                          alt="goods"
                          onClick={() => handleOpenNewTab(goods.url)}
                        />
                      </StyledPaper>
                    )
                  },
                )}
            </CircleImageCarousel>
          ) : (
            <CircleImageScrollBox>
              {circleInfo?.data.userBoothApplication.goods_list.length > 0 &&
                circleInfo?.data.userBoothApplication.goods_list.map(
                  (goods) => {
                    return (
                      <StyledPaper key={goods.id}>
                        <img
                          src={goods.url}
                          alt="goods"
                          onClick={() => handleOpenNewTab(goods.url)}
                        />
                      </StyledPaper>
                    )
                  },
                )}
            </CircleImageScrollBox>
          )}

          <CircleDetailInfoBox>
            <CircleDetailInfo>
              <div className="title">서클 소개</div>
              <div className="content">
                {circleInfo?.data.userBoothApplication?.introduce || ''}
              </div>
            </CircleDetailInfo>
            <CircleDetailInfo>
              <div className="title">판매 굿즈</div>
              <div className="content">
                {circleInfo?.data.userBoothApplication.goods_type
                  .split(',')
                  .map((goods) => {
                    return (
                      <span key={goods}>
                        {GoodsType[goods as keyof typeof GoodsType]}{' '}
                      </span>
                    )
                  })}
              </div>
            </CircleDetailInfo>
          </CircleDetailInfoBox>
        </Wrapper>
      )}
    </>
  )
}

export default CircleDetail

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  box-sizing: border-box;
  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: calc(80px + ${theme.size.headerHeight}px);
  margin-bottom: 120px;
  padding: 24px;

  border: 1px solid #c1c3c2;
  border-radius: 12px;

  @media ${theme.device.large} {
    gap: 24px;

    /* align-items: start; */

    width: 100%;
    height: auto;
    margin-top: calc(56px + ${theme.size.headerHeight}px);
  }
`

const BackgroundImage = styled.img`
  position: absolute;
  z-index: ${theme.zIndex.belowBackground};
  top: 0;
  left: 0;

  overflow: hidden;

  width: 100vw;
  height: 100vh;

  object-fit: cover;
  background-repeat: repeat repeat;

  @media ${theme.device.medium} {
    /* height: 100%; */
    background-repeat: repeat;
  }
`

const CircleMainInfoBox = styled.div`
  display: flex;
  gap: 40px;

  box-sizing: border-box;
  height: auto;
  padding: 20px 0;

  border-bottom: 1px solid #c1c3c2;

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 20px;
    height: auto;
  }
`

const CircleThumbnail = styled.img`
  cursor: pointer;
  width: 347px;
  height: 347px;
  object-fit: cover;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
    margin: 0 auto;
  }
`

const CircleMainInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .title {
    font-family: NanumSquareNeo-Bold, sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 45px;

    @media ${theme.device.medium} {
      font-size: 24px;
    }
  }

  .hashtags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }

  .hashtag {
    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    color: ${theme.colors.mint_3};
  }
`

const StyledButton = styled(Button)`
  width: fit-content;
  height: 58px;
  background-color: transparent;
  border: 2px solid #313634;

  a {
    font-size: 18px;
    color: ${theme.colors.black};
    text-decoration: none;
  }

  @media ${theme.device.medium} {
    margin: 20px 0;
    font-size: 15px;
  }
`

const CircleImageScrollBox = styled.div`
  cursor: pointer;

  overflow: visible;
  overflow-x: scroll;
  display: flex;
  gap: 20px;

  width: 100%;
  height: fit-content;

  img {
    width: 347px;
    height: 347px;
    object-fit: cover;
  }
`

const CircleImageCarousel = styled(Carousel)`
  cursor: pointer;
  overflow: visible;
  width: 100%;
  height: 100%;

  &.css-ohwg9z {
    overflow: visible;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const StyledPaper = styled(Paper)`
  overflow: visible;
`

const CircleDetailInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: space-between;

  width: 100%;

  @media ${theme.device.medium} {
    flex-direction: column;
  }
`

const CircleDetailInfo = styled.div`
  width: 100%;

  .title {
    margin: 20px 0;
    font-family: NanumSquareNeo-Bold, sans-serif;
    font-size: 32px;

    @media ${theme.device.medium} {
      font-size: 21px;
    }
  }

  .content {
    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 18px;
    line-height: 140%;
    white-space: pre-wrap;

    @media ${theme.device.medium} {
      font-size: 15px;
    }
  }

  @media ${theme.device.medium} {
    width: 100%;
  }
`

const TagBox = styled.div`
  display: flex;
  gap: 36px;
  line-height: 140%;

  .desc {
    font-family: NanumSquareNeo-Regular, sans-serif;
  }

  &.center {
    align-items: center;

    @media ${theme.device.medium} {
      align-items: start;
    }
  }

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
`
